import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/discourse': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M225.9 32c122.7 0 222.1 102.3 222.1 223.9 0 121.6-99.4 223.9-222.1 223.9l-225.8 0.2s-0.1-224-0.1-227.9c0-121.6 103.3-220.1 225.9-220.1zM224 384c70.7 0 128-57.3 128-128s-57.3-128-128-128-128 57.3-128 128c0 22.1 5.6 42.9 15.4 61l-22.9 75 81.1-20.1c16.5 7.8 35 12.1 54.4 12.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/discourse.js
// module id = 794
// module chunks = 0